// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2e1YW","content":"styles_content__3Igjr","selectAll":"styles_selectAll__1PwiN"};